import { FeatureType } from "@/enums";
import { Feature } from "@/types/Feature";
import { namespace as featureNamespace } from "../modules/features/features";
import { Store } from "vuex";

export class FeaturesStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Get a feature by featureType */
    public async featureByType(featureType: FeatureType): Promise<Feature> {
        return await this.store.dispatch(`${featureNamespace}/GetFeatureByType`, featureType);
    }

    /** Get loaded features. returns [] if not loaded*/
    public get features(): Feature[] {
        return this.store.getters[`${featureNamespace}/GetCurrentFeatures`];
    }

    /** Load the current features*/
    public async loadCurrentFeatures(): Promise<Feature[] | null> {
        return await this.store.dispatch(`${featureNamespace}/loadCurrentFeatures`);
    }
}
